import { useMemo } from 'react'
import { Alert, Typography } from '@mui/material'
import { GridColDef, GridRenderCellParams } from '@mui/x-data-grid-pro'

import SimpleTable from '../simple-table'

const columns = [
  {
    field: 'device',
    headerName: 'Devices Being Replaced',
    flex: 3,
    sortable: false,
    renderCell: (params: GridRenderCellParams) => (
      <Typography
        sx={{
          paddingY: 2,
        }}
      >
        {params.value}
      </Typography>
    ),
  },
  {
    field: 'location',
    headerName: 'Location',
    flex: 2,
    sortable: false,
    renderCell: (params: GridRenderCellParams) => (
      <Typography
        sx={{
          paddingY: 2,
        }}
      >
        {params.value}
      </Typography>
    ),
  },
  {
    field: 'locationNote',
    headerName: 'Note',
    flex: 3,
    sortable: false,
    renderCell: (params: GridRenderCellParams) => (
      <Typography
        sx={{
          paddingY: 2,
        }}
      >
        {params.value}
      </Typography>
    ),
  },
] satisfies GridColDef[]

const ReorderDevicesTable = ({ expandedDetails }: { expandedDetails: IReorderDetail }) => {
  const { devices } = expandedDetails
  const rows = useMemo(
    () =>
      devices.map((d, idx) => ({
        id: idx,
        device: [d.name, d.uniqueId].join(' • '),
        location: d.location,
        locationNote: d.note,
      })),
    [devices]
  )

  if (rows.length === 0)
    return (
      <Alert severity="error" sx={{ marginTop: 2 }}>
        No devices found
      </Alert>
    )
  return <SimpleTable columns={columns} rows={rows} />
}

export default ReorderDevicesTable
